<template>
  <b-container id='device-select-form' class="p-0 m-0">
    <b-form-group v-if="$UIPrivilegeUpdate('devices', 'ssedisplay_groups' ) || $UIPrivilegeUpdate('devices', 'devicegroups')"
      :label="$t('device_groups.add_device_to_group')"
      :label-for="'select-devices'"
    >
      <b-container class="m-0 p-0">

        <SelectList
          id="select-devices"
          :options="deviceOptions"
          v-model="selectListValue"
          :searchable="true"
          :clearable="false"
          @select="addDevice"
          :disabled="disabledFields"
          :placeholder="$t('device_groups.select_display')"
        />
      </b-container>
      <b-container class="p-0 text-right">
        <b-button
          :disabled="noDevicesAvailable || disabledFields"
          @click="addAllDevices"
          variant="primary"
          size="sm"
          class="m-0"
        >
          {{ $t('dispatching.messages.selectAll') }}
        </b-button>
        <b-button
          :disabled="!devicesInGroup || disabledFields"
          @click="removeAllDevices"
          variant="warning"
          size="sm"
          class="my-0 ml-1 mr-0"
          >{{ $t('dispatching.messages.clear') }}
        </b-button>
      </b-container>
    </b-form-group>
    <b-form-group
      id="label-table-device"
      :label="$t('device_groups.devices_in_group')"
      :label-for="'table-devices'"
    >
      <b-container
        id="table-devices"
        class="border p-1 rounded m-0"
        v-if="devicesInGroup && !disabledFields"
      >
        <b-table
          id='group-devices-table'
          :items="selectedDevices"
          :fields="fields"
          :sort-by="'label'"
          sticky-header
          style='overflow-x: hidden'
          striped
        >
        <template v-if="$UIPrivilegeUpdate('devices', 'ssedisplay_groups' ) || $UIPrivilegeUpdate('devices', 'device_groups')" v-slot:cell(remove)="row">
            <b-button
              variant="outline-danger"
              class="w-80 h-100 mh-100 p-0 remove-btn"
              v-b-tooltip.hover.right="
                $t('device_groups.remove_device_from_group')
              "
              @click="removeDevice(row.item.deviceId)"
              ><b-icon class="m-1" icon="x-circle" scale="1.15"
            /></b-button>
         </template>
        </b-table>
      </b-container>

      <b-container
        v-if="!devicesInGroup && !disabledFields"
        class="p-0 m-0"
      >
        {{ $t('device_groups.empty_group') }}
      </b-container>
    </b-form-group>

  </b-container>
</template>

<script>
import device from '@/store/displays/device'

export default {
  components: {},
  props: {
    devices: { type: Array, require: true },
    disabledFields: { default: false },
    deviceType: String
  },
  data() {
    return {
      selectListValue: 0,
      selectedDevices: [...this.devices],
      fields: [
        { key: 'uniqueId', label: 'ID', sortable: true },
        { key: 'name', label: this.$t('device_groups.name'), sortable: true },
        { key: 'type', label: this.$t('device_groups.type'), sortable: true },
        { key: 'remove', label: '' },
      ]
    }
  },
  beforeCreate() {
    if (!this.$store.state.device) {
      this.$store.registerModule('device', device)
    }
    this.$store.dispatch('device/getDeviceList')
  },

  watch: {
    devices: function (val) {
      this.selectedDevices = [...val]
    },
  },
  computed: {
    deviceList() {
      let devices = this.$store.state.device.deviceList;
      if(this.deviceType)
        devices = devices.filter(device => device.type === this.deviceType);

      return devices;
    },
    deviceOptions() {
        var optionList = [];
        optionList.push( { id: 0, label: this.$t('infopoints.groups_add'), icon: 'plus', caption: this.$t('infopoints.groups_add') } ); 
       
        for (let device of this.deviceList) {
          if(!this.selectedDevices.some(nd => nd.deviceId === device.deviceId ))
            optionList.push( { id: device.deviceId, label: "["+ device.uniqueId + "] " + device.name } );
        }
        
        return optionList;
    },
    devicesInGroup(){
      return this.selectedDevices.length > 0;
    },
    noDevicesAvailable(){
      return this.deviceOptions.length <= 1;
    },
  },
  
  methods: {

    updateDevices() {
      this.$emit('updateDevices', this.selectedDevices)
    },
    addDevice(id){
      let selectedDevice = this.deviceList.find(device => device.deviceId === id);
      if(selectedDevice){
        this.selectedDevices.push(selectedDevice);
        this.updateDevices();
      }  
    },
    addAllDevices(){
      // TODO
    },
    removeDevice(id){
      this.selectedDevices = this.selectedDevices.filter(device => device.deviceId != id);
      this.updateDevices();
    },
    removeAllDevices(){
      this.selectedDevices = [];
      this.updateDevices();
    }



/*
    deviceSelected(value) {
      const selected = this.devicesToChoose.find((item) => {
        return item.uniqueId == value
      })
      // this.selectListValue = selected.label
      this.selectListValue = ' '

      if (!this.newDevices.includes(selected)) {
        this.newDevices.push(selected)
        this.updateDevices()
      }
    },
    unselectDevice(item) {
      const index = this.newDevices.indexOf(item)
      if (index > -1) {
        this.newDevices.splice(index, 1)
        this.updateDevices()
        this.selectListValue = ' '
      }
    },
    selectAllDevices() {
      // this.devicesToChoose.forEach((it) => {
      //   this.devices.push(it)
      // })
      this.newDevices = this.newDevices.concat(this.devicesToChoose)
      this.updateDevices()
      this.selectListValue = this.$t('select_and_tables.all_choosen')
    },
    clearChoosenDevices() {
      //   this.newDevices.length = 0
      this.newDevices = []
      this.updateDevices()
      this.selectListValue = ' '
    },
    */
  },
}
</script>

<style lang="scss">
  
  #group-devices-table {
    td {
      padding: 2px 5px;
    }
  }
 
</style>
